import React, { createContext, useContext, useState } from 'react';
import { Routes, Route } from 'react-router';
import DocumentAnalyzerPage from './pages/DocumentAnalyzerPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import HomePage from './pages/HomePage';
import NotFoundPage from './pages/NotFoundPage';
import ErrorBoundary from './components/ErrorBoundary';
import GlobalSpinner from './components/GlobalSpinner';

// Global loading context
const LoadingContext = createContext<{ loading: boolean; setLoading: (v: boolean) => void }>({ loading: false, setLoading: () => {} });
export const useLoading = () => useContext(LoadingContext);

const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(false);
  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {loading && <GlobalSpinner />}
      {children}
    </LoadingContext.Provider>
  );
};

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <LoadingProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/analyze" element={<DocumentAnalyzerPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/verify_email/:token" element={<VerifyEmailPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </LoadingProvider>
    </ErrorBoundary>
  );
};

export default App;
